import { jsxs as m, jsx as t, Fragment as S } from "react/jsx-runtime";
import { useState as k } from "react";
import { Box as r, Stack as b } from "@mui/material";
import { T as x } from "./Typography-HkIo7ajX.js";
import { f as $, c as y } from "./DropdownMultipleSearch-COvERzNg.js";
import "@mui/material/Button";
import "@mui/material/styles";
import "@mui/material/CssBaseline";
import { s as i } from "./spacings-C27fg6SF.js";
import "@fortawesome/pro-regular-svg-icons";
import "@fortawesome/react-fontawesome";
import "@fortawesome/fontawesome-svg-core";
import "@mui/material/Box";
import "@mui/material/Checkbox";
import "@fortawesome/pro-solid-svg-icons";
import "@fortawesome/pro-light-svg-icons";
import "@mui/material/Stack";
import "@mui/material/Link";
import "@mui/material/Typography";
import "@mui/material/Tooltip";
import "@mui/material/Fade";
import "@fortawesome/pro-regular-svg-icons/faXmark";
import "@mui/material/useAutocomplete";
import "@emotion/cache";
import "@emotion/react";
import "@mui/material/Chip";
import "@fortawesome/pro-solid-svg-icons/faCircle";
import "@mui/material/Avatar";
import "@fortawesome/pro-light-svg-icons/faUser";
import "@mui/material/AvatarGroup";
import "@fortawesome/pro-regular-svg-icons/faPlus";
import "@mui/material/LinearProgress";
import "@mui/material/Tabs";
import "@mui/material/Tab";
import "@mui/material/ButtonGroup";
import "@mui/material/Switch";
import "@mui/material/Radio";
import "@mui/material/FormLabel";
import "@mui/material/Autocomplete";
import "@mui/material/FormHelperText";
import "@mui/material/FormControl";
import "@mui/material/OutlinedInput";
import "@mui/material/InputAdornment";
import "@fortawesome/pro-regular-svg-icons/faMagnifyingGlass";
import "@fortawesome/pro-solid-svg-icons/faCheck";
import "@fortawesome/pro-regular-svg-icons/faCircleQuestion";
import "@vidstack/react";
import "@vidstack/react/player/layouts/default";
import "@vidstack/react/player/styles/default/theme.css";
import "@vidstack/react/player/styles/default/layouts/video.css";
import "@vidstack/react/icons";
import "@fortawesome/pro-light-svg-icons/faArrowUpRightFromSquare";
import "@fortawesome/pro-solid-svg-icons/faArrowRight";
import "@mui/material/Popper";
import "copy-text-to-clipboard";
import "@fortawesome/pro-solid-svg-icons/faExpandWide";
import "@fortawesome/pro-solid-svg-icons/faCompressWide";
import "@fortawesome/pro-solid-svg-icons/faUpRightAndDownLeftFromCenter";
import "@fortawesome/pro-solid-svg-icons/faDownLeftAndUpRightToCenter";
import "@fortawesome/pro-solid-svg-icons/faChevronsRight";
import "@fortawesome/pro-solid-svg-icons/faChevronsLeft";
import "@fortawesome/pro-solid-svg-icons/faToggleLargeOn";
import "@fortawesome/pro-solid-svg-icons/faToggleOff";
import "@fortawesome/pro-solid-svg-icons/faEye";
import "react-rnd";
import "react-use";
import "react-hotkeys-hook";
import "@react-spring/web";
import "./AutoScrollContainer-CzyjIY1o.js";
import "@tanstack/react-table";
import "@fortawesome/pro-regular-svg-icons/faArrowRight";
import "@fortawesome/pro-regular-svg-icons/faArrowLeft";
import "@fortawesome/pro-regular-svg-icons/faPenToSquare";
import "@fortawesome/pro-regular-svg-icons/faCircleXmark";
import "@fortawesome/pro-regular-svg-icons/faArrowDown";
import { P as A } from "./PolicyAndTermsLinks-C0ktDBVB.js";
import { G as J, M as K } from "./MicrosoftIcon-BAfd0N_m.js";
import { L as N } from "./Logo-agH5zvpp.js";
const Q = (o) => o ? /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(o) ? "" : "Enter a valid email" : "Field is required", W = ({ onSubmit: o, buttonLabel: e, initialEmail: p = "", isButtonDisabled: d }) => {
  const [n, c] = k(p), [h, l] = k(""), u = () => {
    c(p), l("");
  };
  return /* @__PURE__ */ m(
    "form",
    {
      onSubmit: (a) => {
        a.preventDefault();
        const s = Q(n);
        if (s) {
          l(s);
          return;
        }
        o(n, u);
      },
      children: [
        /* @__PURE__ */ t(
          r,
          {
            sx: {
              "& .MuiInputBase-root": {
                height: "40px"
              }
            },
            children: /* @__PURE__ */ t(
              $,
              {
                value: n,
                onChange: (a) => {
                  l(""), c(a.target.value);
                },
                label: "Email*",
                placeholder: "Enter your email",
                ...!!h && { errorText: "The email address is incorrect" }
              }
            )
          }
        ),
        /* @__PURE__ */ t(r, { mt: i["3xl"] }),
        /* @__PURE__ */ t(
          y,
          {
            disabled: d || !n.trim(),
            size: "large",
            color: "primary",
            type: "submit",
            variant: "contained",
            fullWidth: !0,
            children: e
          }
        )
      ]
    }
  );
}, T = ({ title: o, subtitle: e = "" }) => /* @__PURE__ */ m(S, { children: [
  /* @__PURE__ */ t(
    r,
    {
      display: "flex",
      justifyContent: "center",
      width: "100%",
      children: /* @__PURE__ */ t(
        x,
        {
          variant: "heading",
          size: "sm",
          align: "center",
          fontWeight: "semibold",
          color: "text.primary",
          children: o
        }
      )
    }
  ),
  !!e && /* @__PURE__ */ t(
    r,
    {
      display: "flex",
      justifyContent: "center",
      width: "100%",
      mt: i.lg,
      children: /* @__PURE__ */ t(
        x,
        {
          variant: "text",
          align: "center",
          size: "md",
          color: "grey.600",
          children: e
        }
      )
    }
  )
] }), U = ({
  buttonlabel: o,
  title: e,
  isButtonDisabled: p,
  subtitle: d = "",
  onSubmit: n,
  onAlternativeActionClick: c,
  alternativeText: h,
  alternativeActionLabel: l,
  privacyPolicyLink: u,
  termsLink: a
}) => /* @__PURE__ */ m(S, { children: [
  /* @__PURE__ */ t(
    T,
    {
      title: e,
      subtitle: d
    }
  ),
  /* @__PURE__ */ t(r, { mt: i["4xl"] }),
  /* @__PURE__ */ t(
    W,
    {
      isButtonDisabled: p,
      buttonLabel: o,
      onSubmit: (s, f) => {
        n({
          email: s,
          isSsoLogin: !0,
          resetForm: f
        });
      }
    }
  ),
  /* @__PURE__ */ t(r, { mt: i["4xl"] }),
  /* @__PURE__ */ t(
    A,
    {
      privacyPolicyLink: u,
      termsLink: a
    }
  ),
  /* @__PURE__ */ m(
    b,
    {
      direction: "row",
      justifyContent: "center",
      mt: i["3xl"],
      spacing: i.xs,
      children: [
        /* @__PURE__ */ t(
          r,
          {
            sx: { cursor: "pointer" },
            onClick: () => {
              c();
            },
            children: /* @__PURE__ */ t(
              x,
              {
                variant: "text",
                size: "sm",
                fontWeight: "semibold",
                color: "primary.700",
                children: l
              }
            )
          }
        ),
        /* @__PURE__ */ t(
          x,
          {
            variant: "text",
            size: "sm",
            color: "grey.600",
            children: h
          }
        )
      ]
    }
  )
] }), V = ({
  buttonlabel: o,
  initialEmail: e,
  shouldHideMagicLinkLogin: p,
  onSsoClick: d = () => {
  },
  onGoogleClick: n,
  onMicrosoftClick: c,
  title: h,
  alternativeText: l,
  onAlternativeActionClick: u,
  isButtonDisabled: a,
  alternativeActionLabel: s,
  subtitle: f = "",
  onSubmit: v,
  privacyPolicyLink: C,
  termsLink: w
}) => /* @__PURE__ */ m(S, { children: [
  /* @__PURE__ */ t(
    T,
    {
      title: h,
      subtitle: f
    }
  ),
  /* @__PURE__ */ t(r, { mt: i["4xl"] }),
  /* @__PURE__ */ t(
    y,
    {
      fullWidth: !0,
      variant: "outlined",
      color: "secondary",
      size: "large",
      startIcon: J,
      onClick: n,
      children: "Continue with Google"
    }
  ),
  /* @__PURE__ */ m(
    b,
    {
      direction: "row",
      spacing: i.xl,
      mt: i["4xl"],
      children: [
        /* @__PURE__ */ t(
          y,
          {
            fullWidth: !0,
            variant: "outlined",
            color: "secondary",
            size: "large",
            onClick: c,
            startIcon: K,
            children: "Microsoft"
          }
        ),
        /* @__PURE__ */ t(
          y,
          {
            fullWidth: !0,
            variant: "outlined",
            color: "secondary",
            size: "large",
            onClick: d,
            children: "SSO"
          }
        )
      ]
    }
  ),
  !p && /* @__PURE__ */ m(S, { children: [
    /* @__PURE__ */ m(
      b,
      {
        mt: i["3xl"],
        mb: i["4xl"],
        spacing: i.xl,
        direction: "row",
        alignItems: "center",
        children: [
          /* @__PURE__ */ t(
            r,
            {
              height: "1px",
              width: "100%",
              bgcolor: (g) => g.palette.grey[200]
            }
          ),
          /* @__PURE__ */ t(
            x,
            {
              variant: "text",
              size: "md",
              children: "OR"
            }
          ),
          /* @__PURE__ */ t(
            r,
            {
              height: "1px",
              width: "100%",
              bgcolor: (g) => g.palette.grey[200]
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ t(
      W,
      {
        isButtonDisabled: a,
        buttonLabel: o,
        initialEmail: e,
        onSubmit: (g, z) => {
          v({
            email: g,
            resetForm: z
          });
        }
      }
    )
  ] }),
  /* @__PURE__ */ t(r, { mt: i["4xl"] }),
  /* @__PURE__ */ t(
    A,
    {
      privacyPolicyLink: C,
      termsLink: w
    }
  ),
  /* @__PURE__ */ m(
    b,
    {
      direction: "row",
      justifyContent: "center",
      mt: i["3xl"],
      spacing: i.xs,
      children: [
        /* @__PURE__ */ t(
          x,
          {
            variant: "text",
            size: "sm",
            color: "grey.600",
            children: l
          }
        ),
        /* @__PURE__ */ t(
          r,
          {
            sx: { cursor: "pointer" },
            onClick: () => {
              u();
            },
            children: /* @__PURE__ */ t(
              x,
              {
                variant: "text",
                size: "sm",
                fontWeight: "semibold",
                color: "primary.700",
                children: s
              }
            )
          }
        )
      ]
    }
  )
] }), Si = ({
  privacyPolicyLink: o,
  termsLink: e,
  isLoading: p,
  ssoTitle: d,
  ssoSubtitle: n,
  signAlternativeActionLabel: c,
  ssoAlternativeText: h,
  ssoAlternativeActionLabel: l,
  onAlternativeLabelClick: u = () => {
  },
  subtitle: a,
  primaryButtonlabel: s,
  initialEmail: f = "",
  isLargeLogo: v = !0,
  title: C,
  alternativeText: w = "",
  shouldDisableMainButton: g,
  shouldShowLogo: z,
  shouldHideMagicLinkLogin: B = !1,
  maxWidth: F = 465,
  onMicrosoftClick: M,
  onGoogleClick: D,
  onSubmit: G
}) => {
  const [O, I] = k(!1), L = async ({ email: R, isSsoLogin: q, resetForm: H }) => {
    const E = R.trim(), P = E.substring(E.lastIndexOf("@") + 1);
    G({
      isSsoLogin: q,
      email: E,
      domain: P,
      resetForm: H
    });
  }, j = p || g;
  return /* @__PURE__ */ m(
    r,
    {
      maxWidth: F,
      width: "100%",
      children: [
        !!z && /* @__PURE__ */ t(
          r,
          {
            width: "100%",
            display: "flex",
            justifyContent: "center",
            mb: i["4xl"],
            children: /* @__PURE__ */ t(
              N,
              {
                variant: "brand",
                type: "full",
                height: v ? 60 : 40
              }
            )
          }
        ),
        O ? /* @__PURE__ */ t(
          U,
          {
            buttonlabel: s,
            title: d,
            isButtonDisabled: j,
            subtitle: n,
            onSubmit: L,
            privacyPolicyLink: o,
            termsLink: e,
            alternativeText: h,
            onAlternativeActionClick: () => {
              I(!1);
            },
            alternativeActionLabel: l
          }
        ) : /* @__PURE__ */ t(
          V,
          {
            title: C,
            privacyPolicyLink: o,
            shouldHideMagicLinkLogin: B,
            termsLink: e,
            subtitle: a,
            isButtonDisabled: j,
            buttonlabel: s,
            initialEmail: f,
            alternativeText: w,
            alternativeActionLabel: c,
            onSubmit: L,
            onAlternativeActionClick: u,
            onSsoClick: () => {
              I(!0);
            },
            onGoogleClick: D,
            onMicrosoftClick: M
          }
        )
      ]
    }
  );
};
export {
  Si as S
};
